import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanDeactivateFn
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { PayrollManagement } from '../tools/payroll-management';
import {
  correctionPayrollDetailRouteRegex,
  correctionPayrollPreviewRouteRegex,
  correctionPayrollRouteRegex
} from '../utils/regex-patterns';
import { MasterPayrollObject, PayrollStatuses } from '../models/payroll';

export interface IPayrollCorrectionsPage {
  payroll: MasterPayrollObject;
  payrollMgmt: PayrollManagement;
}

// NOTE: mimic this setup to eliminate usage of depreciated CanDeactivate
export const canDeactivateCorrectionsGuard: CanDeactivateFn<IPayrollCorrectionsPage> = (
  c: IPayrollCorrectionsPage,
  route: ActivatedRouteSnapshot,
  currentState?: RouterStateSnapshot,
  nextState?: RouterStateSnapshot
): Observable<boolean> | boolean => {
  // if user is navigating to anywhere other than a correction payroll screen
  // and the payroll has not been cancelled
  if (
    c.payroll &&
    !c.payroll.IsCancelled &&
    c.payroll.Status == PayrollStatuses.Started &&
    !correctionPayrollRouteRegex.test(nextState?.url) &&
    !correctionPayrollDetailRouteRegex.test(nextState?.url) &&
    !correctionPayrollPreviewRouteRegex.test(nextState?.url)
  ) {
    return c.payrollMgmt.onCorrectionPayrollDeactivate(c.payroll);
  }

  return of(true);
};
